import { WeCallRequestInterface } from '../../../interfaces/request/we-call/we-call-request-interface';

export class CpWeCallRequestModel implements WeCallRequestInterface {
  cardNumber: string = '';
  email: string = '';
  phone: string = '';

  constructor(init?: Partial<CpWeCallRequestModel>) {
    Object.assign(this, init);
  }
}
